import { createEl } from "@/client/utils/createEl";
import { badge, type BadgeVariants } from "./badge.css";

export interface BadgeOptions extends NonNullable<BadgeVariants> {
    text: string;
}

export const createBadge = (
    options: BadgeOptions,
    init?: (el: HTMLSpanElement) => void,
): HTMLSpanElement => {
    const className = badge({
        variant: options.variant,
        theme: options.theme,
    });

    return createEl("span", className, options.text, init);
};
